export const countries = [
    {name: 'Albanie', code: 'AL'},
    {name: 'Allemagne', code: 'DE'},
    {name: 'Andorre', code: 'AD'},
    {name: 'Autriche', code: 'AT'},
    {name: 'Belgique', code: 'BE'},
    {name: 'Biélorussie', code: 'BY'},
    {name: 'Bosnie-Herzégovine', code: 'BA'},
    {name: 'Bulgarie', code: 'BG'},
    {name: 'Chypre', code: 'CY'},
    {name: 'Croatie', code: 'HR'},
    {name: 'Danemark', code: 'DK'},
    {name: 'Espagne', code: 'ES'},
    {name: 'Estonie', code: 'EE'},
    {name: 'Finlande', code: 'FI'},
    {name: 'France', code: 'FR'},
    {name: 'Grèce', code: 'GR'},
    {name: 'Hongrie', code: 'HU'},
    {name: 'Irlande', code: 'IE'},
    {name: 'Islande', code: 'IS'},
    {name: 'Italie', code: 'IT'},
    {name: 'Kosovo', code: 'XK'},
    {name: 'Lettonie', code: 'LV'},
    {name: 'Liechtenstein', code: 'LI'},
    {name: 'Lituanie', code: 'LT'},
    {name: 'Luxembourg', code: 'LU'},
    {name: 'Macédoine du Nord', code: 'MK'},
    {name: 'Malte', code: 'MT'},
    {name: 'Moldavie', code: 'MD'},
    {name: 'Monaco', code: 'MC'},
    {name: 'Monténégro', code: 'ME'},
    {name: 'Norvège', code: 'NO'},
    {name: 'Pays-Bas', code: 'NL'},
    {name: 'Pologne', code: 'PL'},
    {name: 'Portugal', code: 'PT'},
    {name: 'République tchèque', code: 'CZ'},
    {name: 'Roumanie', code: 'RO'},
    {name: 'Royaume-Uni', code: 'GB'},
    {name: 'Russie', code: 'RU'},
    {name: 'Saint-Marin', code: 'SM'},
    {name: 'Serbie', code: 'RS'},
    {name: 'Slovaquie', code: 'SK'},
    {name: 'Slovénie', code: 'SI'},
    {name: 'Suède', code: 'SE'},
    {name: 'Suisse', code: 'CH'},
    {name: 'Ukraine', code: 'UA'},
    {name: 'Vatican', code: 'VA'},
    {name: 'États-Unis', code: 'US'}
];
